import { useTranslation } from "react-i18next";

import { FilterFieldOptionsHookResult } from "~/features/filter";
import { onScrollBottomSubdivision } from "~/hooks/selectSubdivisionValue";

export const useParentSubdivisionOptions = (): FilterFieldOptionsHookResult => {
  const { t } = useTranslation();
  const {
    divisionsForSelect,
    onScrollBottomDivisions,
    searchDivision,
    GetSubdivisionLoading,
  } = onScrollBottomSubdivision();

  return {
    options: [
      { value: "0", label: t("common.without_subdivision") },
      ...divisionsForSelect.map(({ value, label }) => ({
        value: String(value),
        label,
      })),
    ],
    loading: GetSubdivisionLoading,
    onScrollBottom: onScrollBottomDivisions,
    searchOptions: searchDivision,
  };
};
